"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _TablePagination = _interopRequireDefault(require("@mui/material/TablePagination/TablePagination.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _styles = require("@mui/styles");
var _react = _interopRequireWildcard(require("react"));
var _reactMeasure = _interopRequireDefault(require("react-measure"));
var _useDebounce = require("use-debounce");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(({
  palette
}) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  statusText: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '12px',
    fontWeight: 400
  },
  tablePagination: {
    '& .MuiToolbar-root': {
      minHeight: 'auto',
      padding: 0
    },
    '& .MuiInputBase-root': {
      border: `1px solid ${palette.grayscale.lighter}`,
      margin: '0px 4px 0px 0px',
      '& svg': {
        color: palette.text.primary
      }
    },
    '& .MuiButtonBase-root': {
      padding: 8
    },
    '& .MuiTablePagination-displayedRows': {
      margin: 0
    },
    '& .MuiTablePagination-actions': {
      margin: 0
    },
    '& .MuiTablePagination-select': {
      paddingRight: '18px !important'
    },
    '& .MuiTablePagination-actions, .MuiTablePagination-displayedRows': {
      display: p => p.showPageNavigation ? 'block' : 'none'
    }
  }
}));
const Paginator = ({
  activePage,
  pageSize,
  pageCount,
  rowCount,
  pageSizeOptions,
  onPageChange,
  onSizeChange,
  showPageNavigation = true,
  statusText
}) => {
  const [dimensions, setDimensions] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  const classes = useStyles({
    dimensions,
    showPageNavigation
  });
  const handleMeasureChange = (0, _useDebounce.useDebouncedCallback)(contentRect => {
    if (contentRect.offset) {
      setDimensions({
        width: contentRect.offset.width,
        height: contentRect.offset.height
      });
    }
  }, 200);
  const rowsPerPageOptions = pageSizeOptions?.find(pageSizeOption => pageSizeOption === pageSize) ? pageSizeOptions : pageSizeOptions?.concat([pageSize]).sort((num1, num2) => num1 - num2);
  const handlePageChange = (_, page) => {
    onPageChange(page + 1);
  };
  const handleSizeChange = ({
    target: {
      value
    }
  }) => {
    onSizeChange(parseInt(value));
  };
  if (!pageCount) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMeasure.default, {
    offset: true,
    onResize: handleMeasureChange,
    children: ({
      measureRef
    }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      ref: measureRef,
      className: classes.container,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TablePagination.default, {
        component: "div",
        className: classes.tablePagination,
        count: rowCount,
        labelRowsPerPage: "",
        onPageChange: handlePageChange,
        onRowsPerPageChange: handleSizeChange,
        page: activePage - 1,
        rowsPerPage: pageSize,
        rowsPerPageOptions: rowsPerPageOptions.filter(option => option !== rowCount)
      }), !showPageNavigation && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        className: classes.statusText,
        children: statusText
      })]
    })
  });
};
var _default = exports.default = Paginator;